import type { Candidato, CarreirasView } from '../types'

interface CarreirasNavProps {
  view: CarreirasView
  routeType: string
  candidato: Candidato | null
  loggedIn: boolean
  onSair: () => void
  onNavEmpregos: () => void
  onNavSobre: () => void
  onNavMinhas: () => void
  className?: string
}

export function CarreirasNav({
  view,
  routeType,
  candidato,
  loggedIn,
  onSair,
  onNavEmpregos,
  onNavSobre,
  onNavMinhas,
  className = '',
}: CarreirasNavProps) {
  const empregosOn = view === 'empregos' && routeType !== 'sobre'
  const sobreOn = view === 'sobre' || routeType === 'sobre'
  const nome = candidato?.nome || candidato?.email || 'Candidato'

  return (
    <nav className={`cr-top-links cr-top-links--start ${className}`.trim()} aria-label="Links">
      <a
        href="#/"
        className={`cr-nav-link${empregosOn ? ' on' : ''}`}
        onClick={(e) => {
          e.preventDefault()
          onNavEmpregos()
        }}
      >
        Vagas
      </a>
      <a
        href="#/sobre"
        className={`cr-nav-link${sobreOn ? ' on' : ''}`}
        onClick={(e) => {
          e.preventDefault()
          onNavSobre()
        }}
      >
        Sobre
      </a>
      {loggedIn && (
        <a
          href="#/minhas"
          className={`cr-nav-link cr-nav-minhas${view === 'minhas' ? ' on' : ''}`}
          onClick={(e) => {
            e.preventDefault()
            onNavMinhas()
          }}
        >
          Minhas vagas
        </a>
      )}
      <a className="cr-nav-cta" href="/login">
        Área RH
      </a>
      {loggedIn ? (
        <span className="cr-sessao" aria-live="polite">
          <span className="cr-sessao-nome" title={candidato?.email || ''}>
            {nome}
          </span>
          <button type="button" className="cr-sessao-sair" onClick={onSair}>
            Sair
          </button>
        </span>
      ) : null}
    </nav>
  )
}
